<div class="record-container">
  <img class="img" src="/assets/images/record/rec.webp" alt="Teléfono">
  <div class="rec-description" [innerHTML]="'record_Data1' | i18n"></div>
</div>
